__turbopack_context__.v({
  "tabContent": "HowLongTabContent-module__LPCc7q__tabContent",
});
